import { useEffect } from "react";
import { ListSkeleton } from "../../skeletons/List";
import axios from "axios";
import { useState } from "react";
import DataTable from "../../components/Table";
import { Button, Container, Typography } from "@mui/material";
import FloatingActionButtons from "../../components/Fab";
import { useDashboardDrawer } from "../../providers/consumers/useDashboardDrawer";
import { useBuilder } from "../../../hooks/useBuilder";
import store, { clear, setFieldState } from "../../store/formStore";
import { useSelector } from "react-redux";
import GzipHelper from "../../controllers/GzipHelper";

const ListCustomers = () => {
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(true);
    const { pushMobileOpen, defaultOpen, addRouter } = useDashboardDrawer();
    const {builder, form, refs} = useBuilder();

    const elements = useSelector(state => state.elements);

    const columns = [
        { field: 'id', headerName: 'ID', width: 125, headerClassName: 'data-grid-header' },
        { field: 'name', headerName: 'Nome', width: 200, headerClassName: 'data-grid-header' },
        { field: 'brand', headerName: 'Brand', valueGetter: (params) => params.row.status === 'S' ? 'Abilitato' : 'Disabilitato', width: 100, headerClassName: 'data-grid-header'},
        { field: 'type', headerName: 'Tipo Offerta', width: 200, headerClassName: 'data-grid-header' },
        { field: 'type_contract', headerName: 'Tipo cliente', width: 150, valueGetter: (params) => params.row['Visibile Lead'] === 'S' ? 'Abilitato' : 'Disabilitato', headerClassName: 'data-grid-header'},
        { field: 'active', headerName: 'Attiva',  valueGetter: (params) => params.row['Visibile contratto'] === 'S' ? 'Abilitato' : 'Disabilitato', width: 150, headerClassName: 'data-grid-header'},
    ];

    const getCustomers = async() => {
        const res = await axios.get('https://l48oatxneb.execute-api.eu-west-1.amazonaws.com/testnet/api/v1/customer');
        const unzipped = await GzipHelper.unzip(res.data);
        setCustomers([...unzipped]);
        setLoading(false);
    }
    useEffect(() => {
        getCustomers();
        store.dispatch(clear())
        builder('customers.add');
    }, [])

    const handleClick = (data, name = null) => {
        store.dispatch(clear())
        builder('customers.add');
        if(data.row){
            Object.keys(data.row).forEach((key) => {
                store.dispatch(setFieldState({name: key, value: data.row[key]}));
            });
        }
        pushMobileOpen(true, 500, name ? name : "Modifica committente", data.row);

    }
    return (<Container sx={{paddingLeft: 24, paddingRight: 24, minWidth: '100vw', marginTop: '3rem'}}>
    
    <Typography variant="h4" color="primary" fontWeight="bold" textAlign="left" sx={{paddingBottom: '2rem', fontWeight: 'bold'}}>Lista committenti</Typography>
    
    {loading && <ListSkeleton />}
    {!loading && <DataTable data={customers} columns={columns} handleClick={handleClick} actions={[
        {type: 'select', name: 'Azioni'}
    ]}/>}
    <FloatingActionButtons onClick={() => handleClick([], "Crea Committente")}/>
    </Container>);
}

export default ListCustomers;